/**
 * @todo implement method to overwrite action-url
 */
oyc.Pager = {
  dependencies: ['FormStateTracking'],
  selectors: {
    container: '.pageable-container',
    list: '.pageable-list',
    items: '.list-item',
    currentPage: '.pager-current',
    loadButton: '.pager-execute',
    loadButtonFallback: '.pager-fallback',
    portalLink: '.pager-portal-link',
    pagination: '.jobs-pagination, .jobs-action, .blogpagination',
    countUpTo: '.count-up-to'
  },
  container: null,
  loadButton: false,
  loadMoreLabel: 'mehr anzeigen',
  result: {},
  /**
   * @var {oyc.FormStateTracking}
   */
  fst: null,
  form: {},
  pagination: {},
  lastPageLoaded: false,

  /**
   * @var {jQuery.jqXHR|false}
   */
  nextPage: false,
  init: function () {
    this.container = $(this.selectors.container);
    if (0 < this.container.length) {
      this.fst = oyc.FormStateTracking;
      this.container.each(this.initContainer.bind(this));
      this.addEvents();
    }
  },
  initContainer: function (i, el) {
    let container = $(el), containerId = container.attr('id');

    let form = this.retrievePrimaryForm(container);
    this.form[containerId] = form;
    let pagination = $(this.selectors.pagination);
    if (pagination.length === 0 && (this.form[containerId] === undefined || this.form[containerId] === null)) {
      return;
    }
    if (pagination.length) {
      container.data('load-next-page', false);
      this.initVariantPagination(pagination, containerId);
      this.hideLoader(containerId);
    } else {
      $(form).data('request', false);
      this.initVariantLoadMore(containerId);
    }
  },
  initVariantPagination: function (pagination, containerId) {
    if (0 < pagination.find('.blogpagination__item--next').length) {
      this.pagination[containerId] = pagination;
      this.pagination[containerId].find('[type="submit"], .blogpagination__link, .pager-next').click(this.clickPagination.bind(this));
    } else {
      pagination.remove();
    }
  },
  clickPagination: (ev) => {
    /** {HTMLFormElement} form **/
    let form = ev.currentTarget.form || ev.currentTarget.closest('form');
    let container = $(ev.currentTarget).closest(oyc.Pager.selectors.container), containerId = container.attr('id');

    let method = 'GET', data = {}, url = null, clearList = false;
    if (form === null) {
      url = oyc.Pager.pagination[containerId].find('.blogpagination__item--next a').attr('href');
    } else {
      let formData = new FormData(form);
      formData.set('tx_oycimport_list[page]', ev.currentTarget.value);
      formData.set('container-id', container.id);
      data = formData;
      clearList = true;
      url = form.action;
    }
    ev.preventDefault();
    let paginateXhr = $.ajax(url, {
      method: method,
      data: data,
      processData: false,
      contentType: false
    }).done(oyc.Pager.done.bind(oyc.Pager));
    paginateXhr.containerId = containerId;
    container.data({'request': true, 'immediate-show': true, 'clear-list': clearList});
  },
  initVariantLoadMore: function (containerId) {
    let container = this.container.filter(('#' + containerId)),
      button = container.find(this.selectors.loadButton);
    if (0 === button.length) {
      return;
    }
    // data.currentPage exists if a filter form is existing on the current page (automatically invoking a form submit)
    // if not: the list container has form inside of course and so
    container.data('currentPage', 0);
    container.data('loadButton', button);
    container.data('request', false);
    this.loadFstPage(containerId);
    this.loadNextPage(containerId);

    let limit = 0;
    let limitFieldName = container.data('limit-field-name') || container.find('form').data('fieldNamePrefix') + '[limit]';
    if (limitFieldName) {
      let limitField = container.find('[name="' + limitFieldName + '"]');
      limit = limitField.val();
    } else {
      limit = container.find(this.selectors.items).length;
    }
    container.data('limit', limit);

    if (0 < container.find(this.selectors.portalLink).length) {
      container.find(this.selectors.portalLink).click(function (ev) {
        let form = container.find('form');
        if (0 < form.length) {
          ev.preventDefault();
          let hiddenFieldsIdx = form.filter('.hidden-fields').index();
          if (-1 < hiddenFieldsIdx) {
            let hidden = form.splice(hiddenFieldsIdx, 1);
            if (1 < form.length && 0 < hidden.length) {
              form.append($(hidden).find('[type="hidden"]'));
            }
          }
          form.submit();
        }
      }.bind(this));
    }
  },
  loadFstPage: function (containerId) {
    let lastPageAppended = parseInt(this.fst.getValue('lastPageAppended', this.form[containerId]) || 0)
    if (0 < lastPageAppended && this.lastPageLoaded === false) {
      this.lastPageLoaded = true;
      this.fst.deleteProperty('lastPageAppended', this.form[containerId]);
      if (null === this.form[containerId].querySelector('[name*="loadUpToPage"]')) {
        this.form[containerId].innerHTML += '<input type="hidden" name="' + this.form[containerId].dataset['fieldNamePrefix'] + '[loadUpToPage]" value="' + lastPageAppended + '">';
      }
      let jqForm = $(this.form[containerId]);
      jqForm.data('currentPage', -1);
      jqForm.data('clear-list', true);
    } else {
      // necessary (but dirty fix) to hide the overlay for load processing on existing history
      this.fst.scrollToHistoryPosition(this.form[containerId]);
      this.hideLoader(containerId)
    }
  },
  retrievePrimaryForm: function (container) {
    return container.filter('form').get(0) || container.find('form:not(.hidden-fields)').get(0) || container.find('form').get(0)
  },
  addEvents: function () {
    this.container.find(this.selectors.loadButton).click(this.click.bind(this));
  },
  /**
   * callback for click on button to load more items
   * @param {jQuery.Event} ev
   * @returns {undefined}
   */
  click: function (ev) {
    ev.preventDefault();
    let container = $(ev.currentTarget).closest(this.selectors.container),
      form = container.find('form').get(0) || container.get(0);
    if (this.fst.getValue('scrollTop', form)) {
      this.fst.updateValue('scrollTop');
    }
    $(ev.currentTarget).blur();
    container.trigger({type: 'oyc-pager-click'});
    this.appendItems(true, container.attr('id'));
  },
  /**
   * initialize the request to fetch more items
   * @returns {undefined}
   */
  loadNextPage: function (containerId) {
    let container = $('#' + containerId);
    if (container.data('request') !== false && container.data('request') !== undefined) {
      container.data('immediate-show', true);
      return;
    }
    let args = {};
    container.data('currentPage', parseInt(container.data('currentPage') || 0) + 1);
    let jqForm = $(this.form[containerId]),
      form = this.form[containerId],
      pageFieldName = jqForm.data('pageFieldName')
    if (!pageFieldName && jqForm.data('fieldNamePrefix')) {
      pageFieldName = jqForm.data('fieldNamePrefix') + '[page]';
    } else {
      const pageField = form.querySelector('[name*="page"]');
      pageFieldName = pageField ? pageField.name : 'page';
    }
    if ('Pager' in oyc.static) {
      let url = 'type=';
      if (form.name in oyc.static.Pager) {
        url += oyc.static.Pager[form.name].typeNum;
      }
      args.url = (location.pathname !== '/' ? location.pathname : '') + '/?' + url;
    } else {
      args.url = form.action;
    }
    args.data = new FormData(form);
    args.data.set(pageFieldName, container.data('currentPage'));
    args.data.set('container-id', containerId);

    args.processData = false;
    args.contentType = false;
    this.nextPage = $.post(args);
    this.nextPage.done(this.done.bind(this));
    this.nextPage.containerId = container.attr('id');
    this.nextPage.fail(this.fail.bind(this));
    console.log('oyc.Pager.loadNextPage', args, this.nextPage)
  },
  /**
   * callback function of the request to get mor teasers
   *
   * @param {String|Response} data
   * @param {String|undefined} status
   * @param {Object|undefined} jqXhr
   * @returns {undefined}
   */
  done: async function (data, status, jqXhr) {
    if (status === 'success') {
      this.fetchResponse(data, jqXhr.containerId);
      this.nextPage = false;
    }
  },
  /**
   * extracts the teasers from the request response and store them in member result
   * show the load button if teasers were found
   * @param {String} data
   * @param {string} containerId
   * @returns {undefined}
   */
  fetchResponse: function (data, containerId) {
    let container = this.container.filter('#' + containerId);
    if (!container.hasClass(this.selectors.container.substring(1))) {
      container = container.closest(this.selectors.container);
    }
    let resultData = $('<div>' + data + '</div>').find('#' + containerId);
    if (resultData.length === 0) {
      resultData = $(data).find(this.selectors.container);
    }
    let result = resultData.find(this.selectors.items);

    this.result[containerId] = result;
    if (result.length > 0) {
      this.showLoadButton(containerId);
      container.data('request', false);
      if (container.data('immediate-show') === true || container.data('clear-list') === true) {
        container.data('immediate-show', false);
        let pagination = $(data).find('#' + containerId + ' ' + this.selectors.pagination);
        this.appendItems(container.data('load-next-page'), containerId);
        if (0 < pagination.length) {
          this.replacePagination(pagination, containerId);
        }
      }
    } else {
      this.fail({containerId: containerId});
    }
  },
  replacePagination: function (pagination, containerId) {
    let container = this.container.filter('#' + containerId)
    let oldPagination = container.find(this.selectors.pagination);
    for (let i = 0; i < pagination.length; i++) {
      oldPagination.slice(i, i + 1).replaceWith(pagination[i]);
    }
    this.initVariantPagination(pagination, containerId);
  },
  /**
   * the request for more teaser failed sending and http error status
   * the button is not needed -> hide it
   * @returns {undefined}
   */
  fail: function (jqXhr) {
    this.hideLoadButton(jqXhr.containerId);
    this.container.filter('#' + jqXhr.containerId).data('request', false);
    this.nextPage = false;
  },
  /**
   * called after button click
   * adds this.result and hides button if nothing to add
   * @param {boolean} loadNext whether to call loadNextPage to check for more items
   * @param containerId
   * @returns {undefined}
   */
  appendItems: function (loadNext, containerId) {
    // a container can be a div, a form or an ul-tag
    let container = this.container.parent().find('#' + containerId);
    // ensure we have the container we want and not a form accidentally
    if (!container.hasClass(this.selectors.container.substring(1))) {
      container = container.closest(this.selectors.container);
    }
    let targetElement = container,
      list = targetElement.find(this.selectors.list).get(0);
    if (list) {
      // the container is not the same as the list with the items
      targetElement = $(list);
    }
    let result = this.result[containerId]
    if (container.data('clear-list') === true) {
      // empty list
      targetElement.empty();
      container.data('clear-list', false);
    } else {
      // update number of items shown
      let countUpTo = container.find(this.selectors.countUpTo);
      if (0 < countUpTo.length) {
        let oldAmount = parseInt(countUpTo.text());
        countUpTo.text(oldAmount + result.length);
      }
    }
    result.addClass('fade-in');
    if (result.length < container.data('limit') || 0) {
      this.hideLoadButton(containerId);
    }

    result.each(function (i, el) {
      let item = $(el);
      if (targetElement.find('#' + item.attr('id')).length) {
        return;
      }
      targetElement.append(item);
      let dist = item.find('.distance');
      // append distance (child of title) to location fact
      if (0 < dist.length) {
        item.find('.job-list__item-info__list-item:first-child span').append(dist);
      }
      oyc.Delay.init(item.removeClass, (i + 1) * 50, 'pager-more-item-fade-in-' + i, item, 'fade-in')
    })
    targetElement.trigger('oyc-pager-append-items', [this.result]);

    if (loadNext !== false) {
      this.loadNextPage(containerId);
    }
  },
  /**
   * create the button to load more teasers
   * @returns {undefined}
   */
  showLoadButton: function (containerId) {
    let container = this.container.filter('#' + containerId);
    if (container.data('loadButton')) {
      container.data('loadButton').removeClass('hide');
    }
  },
  /**
   * hide the button for loading more teasers
   * @returns {undefined}
   */
  hideLoadButton: function (containerId) {
    let container = this.container.filter('#' + containerId);
    if (container.data('loadButton')) {
      container.data('loadButton').addClass('hide');
    }
    if (0 < container.find(this.selectors.loadButtonFallback).length) {
      container.find(this.selectors.loadButtonFallback).removeClass('hide');
    }
  },
  showLoader: function (containerId) {
    const container = this.form[containerId].closest(this.selectors.container);
    'Loader' in oyc && oyc.Loader.init(container.id) && oyc.Loader.show(container.id)
  },
  hideLoader: function (containerId) {
    const pageable = this.form[containerId] || this.pagination[containerId];
    if (pageable) {
      const container = pageable.closest(this.selectors.container);
      'Loader' in oyc && oyc.Loader.hide(container.id);
    }
  }

}
